const KeenSlider = window.KeenSlider

const { useReveal, useReset, useUpdate, useArrows, setInitialised } =
  window.BAO.Carousel.plugins
class ProductCardGallery extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    // Check if this gallery is inside another carousel
    if (this.dataset.productCardGalleryInCarousel === 'true') {
      // Disable carousel functionality when inside another carousel
      this.setupStaticGallery()
      return
    }

    if (this.els.slide.elements.length < 2) return

    this.plugins = [useReset(), useUpdate(), setInitialised()]

    if (this.dataset.productCardGalleryUseReveal === 'true') {
      this.plugins.push(useReveal(this.els?.slide?.elements, false))
    }

    if (this.els?.previous?.exists && this.els?.next?.exists) {
      this.plugins.push(
        useArrows({
          next: this.els.next.element,
          previous: this.els.previous.element,
        }),
      )
    }

    this.carousel = this.setupCarousel()
    this.setupArrowHoverListeners()
  }

  setupStaticGallery () {
    // When inside a carousel, just show the first image and hide navigation
    if (this.els?.previous?.exists) {
      this.els.previous.element.style.display = 'none'
    }
    if (this.els?.next?.exists) {
      this.els.next.element.style.display = 'none'
    }
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        rubberband: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 0,
        },
        drag: true,
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 1,
              spacing: 0,
            },
            drag: false,
          },
        },
      },
      this.plugins,
    )
  }

  setupArrowHoverListeners () {
    this.hoverImage = this.querySelector('.prd-Card_Image-hover')

    if (!this.hoverImage) return

    if (this.els?.previous?.exists) {
      this.els.previous.element.addEventListener(
        'mouseenter',
        this.hideHoverImage.bind(this),
      )
      this.els.previous.element.addEventListener(
        'mouseleave',
        this.showHoverImage.bind(this),
      )
    }

    if (this.els?.next?.exists) {
      this.els.next.element.addEventListener(
        'mouseenter',
        this.hideHoverImage.bind(this),
      )
      this.els.next.element.addEventListener(
        'mouseleave',
        this.showHoverImage.bind(this),
      )
    }
  }

  hideHoverImage () {
    if (this.hoverImage) {
      this.hoverImage.style.opacity = '0'
      this.hoverImage.style.visibility = 'hidden'
    }
  }

  showHoverImage () {
    if (this.hoverImage) {
      this.hoverImage.style.opacity = ''
      this.hoverImage.style.visibility = ''
    }
  }
}

if (!customElements.get('product-card-gallery')) {
  customElements.define('product-card-gallery', ProductCardGallery)
}
